import React, { FC, useCallback } from 'react'
import { Layout } from 'components/Layout'
import { CompleteTemplate } from 'components/Templates'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'

const CategoriesComplete: FC = () => {
  const dispatch = useDispatch()
  const backToTopPage = useCallback(() => {
    dispatch(push('/admin/shops'))
  }, [dispatch])

  return (
    <Layout title={'完了 | 商品カテゴリー設定'}>
      <CompleteTemplate
        iconPath={'/icon/done/notification.svg'}
        label={'商品カテゴリー設定を\n更新しました'}
        backToTop={backToTopPage}
      />
    </Layout>
  )
}

export default CategoriesComplete
